import { Button } from 'antd';
import tw from 'twin.macro';

import { NoticeIcon } from '@/assets/svg';
import NoticeBox from '@/components/NoticeBox';
import Table from '@/components/list/Table';
import { useAdjustments } from '@/hooks/queries/universal';

const SettlementIndex = () => {
  const query = useAdjustments();

  return (
    <div css={[tw`flex flex-col gap-[32px]`, tw`[td > .ant-btn]:(my-[-5px])`]}>
      <NoticeBox icon={<NoticeIcon />}>
        자세한 정산 내역은 루커스튜디오를 통해 확인해주세요
      </NoticeBox>

      <Table
        columns={[
          { width: '50%', dataIndex: 'branchName', title: '지점명' },
          {
            width: '50%',
            dataIndex: 'lookerStudioLink',
            title: '정산 내역',
            render: (_, row) => (
              <Button
                type="default"
                target="_blank"
                disabled={!row.lookerStudioLink}
                href={row.lookerStudioLink}
              >
                새 창에서 보기
              </Button>
            ),
          },
        ]}
        dataSource={query.data}
        rowKey={(row) => row.id}
      />
    </div>
  );
};

export default SettlementIndex;
